import { gql } from '@apollo/client'

export const SET_CHANNELS = gql`
  mutation setChannels($channels: [MergedChannel]) {
    setChannels(channels: $channels) @client
  }
`

export const SET_CURRENT_CHANNEL = gql`
  mutation setCurrentChannel($currentChannel: MergedChannel) {
    setCurrentChannel(currentChannel: $currentChannel) @client
  }
`

export const SET_CURRENT_POST = gql`
  mutation setCurrentPost($currentPost: CurrentPost) {
    setCurrentPost(currentPost: $currentPost) @client
  }
`
